"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ApiProvider = void 0;
exports.useApi = useApi;
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /**
* Nom : apiContext.js
* Description : Ce fichier contient des variables disponibles partout dans l'application : 
*               url de l'API, company selectionnée, url de la page précédente
* Date de création : 30 septembre 2025
*/ /* CSS et assets */ // None
/* Bibliothèques et composants */ // None
/* Hook */
var ApiContext = /*#__PURE__*/(0, _react.createContext)(null);
function useApi() {
  return (0, _react.useContext)(ApiContext);
}
var ApiProvider = exports.ApiProvider = function ApiProvider(_ref) {
  var children = _ref.children;
  // Define useState hooks
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    path = _useState2[0],
    setPath = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedCompany = _useState4[0],
    setCompany = _useState4[1];
  var _useState5 = (0, _react.useState)('/'),
    _useState6 = _slicedToArray(_useState5, 2),
    previousUrl = _useState6[0],
    setUrl = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedDate = _useState8[0],
    setDate = _useState8[1];
  var _useState9 = (0, _react.useState)('BOXILUMIX'),
    _useState0 = _slicedToArray(_useState9, 2),
    applicationName = _useState0[0],
    setAppName = _useState0[1];
  var setApiPath = function setApiPath(api_path) {
    setPath(api_path);
  };
  var setSelectedCompany = function setSelectedCompany(company) {
    setCompany(company);
  };
  var setPreviousUrl = function setPreviousUrl(url) {
    setUrl(url);
  };
  var setSelectedDate = function setSelectedDate(date) {
    setDate(date);
  };
  var setApplicationName = function setApplicationName(name) {
    setAppName(name);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ApiContext.Provider, {
    value: {
      path: path,
      setApiPath: setApiPath,
      selectedCompany: selectedCompany,
      setSelectedCompany: setSelectedCompany,
      previousUrl: previousUrl,
      setPreviousUrl: setPreviousUrl,
      selectedDate: selectedDate,
      setSelectedDate: setSelectedDate,
      applicationName: applicationName,
      setApplicationName: setApplicationName
    },
    children: children
  });
};